"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.isSSR = isSSR;
exports.REQUEST_URL = exports.UMS_URL = exports.isServer = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _getEnv = _interopRequireDefault(require("./get-env"));

var isServer = _vue.default.prototype.$isServer;
exports.isServer = isServer;

if (isServer) {
  _vue.default.prototype.$isSSR = true;
}

var UMS_URL = '';
exports.UMS_URL = UMS_URL;
var REQUEST_URL = '';
exports.REQUEST_URL = REQUEST_URL;

function isSSR() {
  return _vue.default.prototype.$isServer || _vue.default.prototype.$isSSR;
}

if (!isServer) {
  var env = (0, _getEnv.default)(location.origin);

  if (env === 'production') {
    exports.REQUEST_URL = REQUEST_URL = 'https://www.gaoding.com';
    exports.UMS_URL = UMS_URL = 'https://ums.gaoding.com';
  } else if (env === 'release') {
    exports.REQUEST_URL = REQUEST_URL = 'https://stage.gaoding.com';
    exports.UMS_URL = UMS_URL = 'https://ums.gaoding.com';
  } else if (env === 'localhost') {
    exports.REQUEST_URL = REQUEST_URL = 'http://www.gaoding.localhost';
    exports.UMS_URL = UMS_URL = 'http://ums.dev.gaoding.com';
  } else {
    exports.REQUEST_URL = REQUEST_URL = 'http://www.dev.gaoding.com';
    exports.UMS_URL = UMS_URL = 'http://ums.dev.gaoding.com';
  }
}